"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const Pagination_1 = __importDefault(require("@mui/material/Pagination"));
const PaginationItem_1 = require("@mui/material/PaginationItem");
const styles_1 = require("@mui/material/styles");
const PREFIX = "Pagination";
exports.classes = {
    root: `${PREFIX}-root`,
    first: `${PREFIX}-first`,
    last: `${PREFIX}-last`
};
exports.Root = (0, styles_1.styled)(Pagination_1.default)(({ theme }) => ({
    [`.${exports.classes.root}`]: {
        [`&.${PaginationItem_1.paginationItemClasses.root}`]: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "16px",
            width: "42px",
            height: "42px",
            padding: "0px",
            margin: "0 6px 0 0",
            borderRadius: "42px"
        },
        [`&.${PaginationItem_1.paginationItemClasses.textPrimary}`]: {
            color: theme.colours.inter
        },
        [`&.${PaginationItem_1.paginationItemClasses.ellipsis}, &[class*=iconButtonStyles-text]`]: {
            fill: theme.colours.inter
        },
        "&.Mui-disabled": {
            opacity: 0.38
        },
        "&.Mui-selected": {
            color: theme.colours.white
        }
    },
    [`.${exports.classes.first}`]: {
        [`&.${PaginationItem_1.paginationItemClasses.root}`]: {
            backgroundColor: "transparent",
            fill: theme.colours.inter
        }
    },
    [`.${exports.classes.last}`]: {
        [`&.${PaginationItem_1.paginationItemClasses.root}`]: {
            backgroundColor: "transparent",
            fill: theme.colours.inter
        }
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3BhZ2luYXRpb24vc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDBFQUFxRDtBQUNyRCxpRUFBcUU7QUFDckUsaURBQThDO0FBRTlDLE1BQU0sTUFBTSxHQUFHLFlBQVksQ0FBQztBQUVmLFFBQUEsT0FBTyxHQUFHO0lBQ3JCLElBQUksRUFBRSxHQUFHLE1BQU0sT0FBTztJQUN0QixLQUFLLEVBQUUsR0FBRyxNQUFNLFFBQVE7SUFDeEIsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0NBQ3ZCLENBQUM7QUFFVyxRQUFBLElBQUksR0FBRyxJQUFBLGVBQU0sRUFBQyxvQkFBYSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3hELENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtRQUNwQixDQUFDLEtBQUssc0NBQXFCLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtZQUNuQyxPQUFPLEVBQUUsTUFBTTtZQUNmLGNBQWMsRUFBRSxRQUFRO1lBQ3hCLFVBQVUsRUFBRSxRQUFRO1lBQ3BCLFFBQVEsRUFBRSxNQUFNO1lBQ2hCLEtBQUssRUFBRSxNQUFNO1lBQ2IsTUFBTSxFQUFFLE1BQU07WUFDZCxPQUFPLEVBQUUsS0FBSztZQUNkLE1BQU0sRUFBRSxXQUFXO1lBQ25CLFlBQVksRUFBRSxNQUFNO1NBQ3JCO1FBQ0QsQ0FBQyxLQUFLLHNDQUFxQixDQUFDLFdBQVcsRUFBRSxDQUFDLEVBQUU7WUFDMUMsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztTQUMzQjtRQUNELENBQUMsS0FBSyxzQ0FBcUIsQ0FBQyxRQUFRLG1DQUFtQyxDQUFDLEVBQUU7WUFDeEUsSUFBSSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztTQUMxQjtRQUNELGdCQUFnQixFQUFFO1lBQ2hCLE9BQU8sRUFBRSxJQUFJO1NBQ2Q7UUFDRCxnQkFBZ0IsRUFBRTtZQUNoQixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1NBQzNCO0tBQ0Y7SUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDckIsQ0FBQyxLQUFLLHNDQUFxQixDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7WUFDbkMsZUFBZSxFQUFFLGFBQWE7WUFDOUIsSUFBSSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztTQUMxQjtLQUNGO0lBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ3BCLENBQUMsS0FBSyxzQ0FBcUIsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1lBQ25DLGVBQWUsRUFBRSxhQUFhO1lBQzlCLElBQUksRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7U0FDMUI7S0FDRjtDQUNGLENBQUMsQ0FBQyxDQUFDIn0=